export default {
  form: {
    owner_phone_number: {
      label: 'Número de teléfono del contacto',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Correo electrónico del contacto',
      placeholder: 'Ingresar correo electrónico',
    },
    owner_first_name: {
      label: 'Nombre',
      placeholder: 'Ingresar nombre',
    },
    owner_last_name: {
      label: 'Apellido',
      placeholder: 'Ingresar apellido',
    },
    owner_dob: {
      label: 'Fecha de nacimiento',
      placeholder: 'Fecha',
    },
    owner_id_number: {
      label: 'Número de identificación (p. ej. número de seguridad social en EE. UU.)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Atrás',
    next: 'Siguiente',
  },
};
